import { render, staticRenderFns } from "./GridActionsMenu.vue?vue&type=template&id=f2809934&scoped=true&"
import script from "./GridActionsMenu.vue?vue&type=script&lang=js&"
export * from "./GridActionsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2809934",
  null
  
)

export default component.exports